import React from "react";

import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";
import type { ImpulseFormShape } from "~/tools/impulse-form";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { WidgetRangeField } from "../../../widget-form/range";
import type { WidgetRange } from "../../../widget-form/range/form-state";
import { SettingsSectionFormField } from "../_field";
import { SettingsSectionGrid } from "../_section-grid";

interface SetupDashboardWidgetYAxisRangeProps {
	range: ImpulseFormShape<{
		min: WidgetRange;
		max: WidgetRange;
	}>;
}

export const YAxisRangeSection: React.FC<SetupDashboardWidgetYAxisRangeProps> = ({ range }) => (
	<Widget>
		<WidgetHeader className="grid-cols-[auto_1fr] uppercase" title="Y-axis Range">
			<FormFieldReset className="ml-auto" state={range} />
		</WidgetHeader>

		<WidgetBody card>
			<SettingsSectionGrid className="grid-cols-[auto_1fr]">
				<SettingsSectionFormField layout="horizontal" state={range.fields.min}>
					<FormLabel>Min</FormLabel>
					<WidgetRangeField name="dashboard-widget-y-axis-min" value={range.fields.min} />
				</SettingsSectionFormField>

				<SettingsSectionFormField layout="horizontal" state={range.fields.max}>
					<FormLabel>Max</FormLabel>

					<WidgetRangeField name="dashboard-widget-y-axis-max" value={range.fields.max} />
				</SettingsSectionFormField>
			</SettingsSectionGrid>
		</WidgetBody>
	</Widget>
);
